import { render, staticRenderFns } from "./p-period-picker.vue?vue&type=template&id=37e3165f&"
import script from "./p-period-picker.vue?vue&type=script&lang=js&"
export * from "./p-period-picker.vue?vue&type=script&lang=js&"
import style0 from "./p-period-picker.vue?vue&type=style&index=0&id=37e3165f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports